<template>
<div class="row m-0 mt-3">
  <div class="col-12 px-0 px-md-3">
    <div class="row m-0 align-items-center cursor" @click="goBack">
      <div class="col-auto pr-1">
        <ios-arrow-back-icon />
      </div>
      <div class="col-auto p-0 mb-1">
        Back
      </div>
    </div>
    <div v-if="isProductLoading" class="text-center">
      <grid-loader :loading="isProductLoading" :color="loaderColor" :size="loaderSize" class="d-inline-block" />
    </div>
    <div v-else>
      <div class="row m-0 my-3">
        <div class="col-md-8 col-lg-9">
          <div class="card">
            <div class="row m-0">
              <div class="col-12 col-md-4 p-0 img_bg">
                <img class="img-fluid" :src="item.thumbnail_url" alt=""  v-if="item.thumbnail_url">
                <img src="../image/placeholder-square.png" alt="" class="img-fluid" v-else>
              </div>
              <div class="col-12 col-md-8 p-3">
                <h4> {{ item.title }}</h4>
                <p> {{ item.description }} </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-3 pr-0">
          <div class="card">
            <div class="row m-0" v-if="item.price">
              <div class="col-12 p-3">
                <div class="row m-0 align-items-center">
                  <div class="col-7 p-0">
                    <h2>R {{ item.price }}</h2>
                  </div>
                  <div class="col-5 p-0">
                    <div class="row m-0 justify-content-center align-items-center">
                      <div class="col text-right p-0" @click.stop="decrementValue">
                        <ios-remove-circle-outline-icon  />
                      </div>
                      <div class="col-4 px-1 text-center mb-2">
                        {{item_quantity}}
                      </div>
                      <div class="col text-left p-0" @click.stop="incrementValue">
                        <ios-add-circle-outline-icon  />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 px-3 pb-3">
                <!-- <span>{{ item.quantity }} left in stock</span> -->
                <button class="btn btn-outline w-100 mt-2" @click="addItem" ref="addToCart">
                  <span v-if="addingStatus == 'adding'">Adding...</span>
                  <span v-else-if="addingStatus == 'added'">Added</span>
                  <span v-else-if="item.soldOut">Sold Out</span>
                  <span v-else>Add to cart</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="col-12 p-3">
                <div class="row m-0 align-items-center">
                  <div class="col-12 p-0">
                    <h2>Contact us</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GridLoader from 'vue-spinner/src/MoonLoader.vue'

export default {
  components: {
    GridLoader
  },
  data () {
    return {
      loaderColor: '#5cb85c',
      loaderSize: '50px',
      addingStatus: 'done',
      item_quantity: 1,
      timer: null
    }
  },
  metaInfo () {
    return {
      title: `${this.item.title}`,
      meta: [
        { name: 'description', content: `${this.item.description}` },
        {
          property: 'fb:app_id',
          content: '2744358572336800'
        },
        { property: 'og:title', content: `${this.item.title}` },
        {
          property: 'og:description',
          content: `${this.item.description}`
        },
        { property: 'og:type', content: 'website' },
        {
          property: 'og:image',
          content: `${this.item.thumbnail_url}`
        },
        {
          property: 'og:url',
          content: `https://${this.shopId}.thehoods.app/#/${this.shopId}/product/${this.item.id}`
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isProductLoading', 'products', 'shopId']),
    item () {
      let id = parseInt(this.$route.params.id)
      if (this.products.length > 0) {
        let filterArr = this.products.filter((item) => {
          return item.id === id
        })
        if (filterArr.length > 0) {
          return filterArr[0]
        }
      }
      return {}
    },
    itemDetails () {
      return { item_id: this.item.id, item_name: this.item.title, item_category: this.item.category || 'uncategorized', price: this.item.price }
    }
  },
  watch: {
    item () {
      this.$analytics.logEvent('view_item', { currency: 'ZAR', value: this.item.price, items: [this.itemDetails] })
    },
    itemDetails () {
      this.$meta().refresh()
    }
  },
  methods: {
    ...mapActions(['updateCart']),
    addItem () {
      this.addingStatus = 'adding'
      const order = {
        item: Object.assign({}, this.item),
        quantity: this.item_quantity,
        isAdd: true
      }
      // console.log(order);
      this.updateCart(order)
      this.$analytics.logEvent('add_to_cart', { currency: 'ZAR', value: this.item.price * this.item_quantity, items: [{ ...this.itemDetails, quantity: this.item_quantity }] })
      this.addingStatus = 'added'
      const ref = this.$refs.addToCart
      this.timer = setTimeout(() => {
        this.addingStatus = 'done'
        this.$nextTick(() => {
          ref.blur()
        })
      }, 2000)
    },
    incrementValue () {
      this.item_quantity++
    },
    decrementValue () {
      if (this.item_quantity > 0) {
        this.item_quantity--
      }
    },
    goBack () {
      clearTimeout(this.timer)
      this.$router.push(`/${this.shopId}/store`)
    }
  }
}
</script>

<style scoped>
.caption-full {
  padding-right: 10px;
  padding-left: 10px;
}

.ratings {
  padding-right: 10px;
  padding-left: 10px;
  color: #d17581;
}
.img_bg {
  background-color: var(--dark-color-01);
}
.dark-mode .img_bg {
  background-color: var(--light-color-04);
}
</style>
